export default {
    top_menu: [
        {name:'Trang Chủ',    id:0},
        {name:'Sự kiện kinh doanh', id:1},
        {name:'Nấu ăn',  id:2},
        {name:'Chính trị',   id:3},
        {name:'Cay',  id:4},
        {name:'Xã hội',   id:5},
        {name:'Sức khỏe',   id:6},
    ],
    read_other: 'Đọc khác',
    read_more:  'Đọc thêm',
    not_found:  'Không tìm thấy',
    read_also:  'Đọc thêm',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». All rights reserved.',
    subscribe: 'đăng ký',

    thank_order: 'CẢM ƠN BẠN ĐÃ ĐẶT HÀNG CỦA BẠN',
    specialist_contact: 'Chuyên gia của chúng tôi sẽ liên lạc với bạn sớm, mong đợi cuộc gọi của chúng tôi',
    attention: 'Chú ý',
    we_value_customers: 'Chúng tôi đánh giá cao từng khách hàng của mình, vì vậy chúng tôi cũng muốn cung cấp cho bạn những sản phẩm đặc biệt với giá đặc biệt chỉ dành cho bạn.',
    hurry: 'Nhanh lên, thời gian kích hoạt giảm giá có hạn! Bạn chỉ có <span id="time" class="time">30:00</span> phút để chọn một trong những sản phẩm độc đáo này:',

    hour_ago1: "giờ trước",
    hour_ago2: "nhiều giờ trước",
    hour_ago3: "nhiều giờ trước",
    new_publications: "Bản tin mới",
    read: "Đọc",
    today_at: "Trong ngày",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "Tin tức hàng đầu",
    leave_already: "Đã rời đi? Chờ tin tức mà chúng tôi đã cậpnhật",
    already_shared: "đã được chia sẻ"
}